(function () {
  'use strict';

  var RETURN_KEY = 'vkB2BPersonalReturn';

  function init() {
    var choice = document.querySelector('[data-vk-b2b-purchase-choice]');
    var dialog = document.querySelector('[data-vk-b2b-personal-dialog]');

    showReturnNoticeIfNeeded();

    if (!choice || !dialog) return;

    var trigger = choice.querySelector('[data-vk-b2b-personal-trigger]');
    var lastTrigger = null;

    if (trigger) {
      trigger.addEventListener('click', function () {
        lastTrigger = trigger;
        // showModal gives native focus trapping and Escape-to-close.
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    }

    Array.prototype.slice.call(dialog.querySelectorAll('[data-vk-b2b-personal-cancel]')).forEach(
      function (button) {
        button.addEventListener('click', function () {
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
        });
      }
    );

    // Native dialog fires 'close' for Escape as well, so focus is restored
    // for every dismissal path.
    dialog.addEventListener('close', function () {
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
    });

    var signOut = dialog.querySelector('[data-vk-b2b-personal-signout]');
    if (signOut) {
      signOut.addEventListener('click', function () {
        // Fallback in case the account host drops return_url: remember where
        // to send the customer and show the notice once they are back.
        try {
          window.sessionStorage.setItem(
            RETURN_KEY,
            signOut.getAttribute('data-vk-b2b-return-url') || window.location.pathname
          );
        } catch (error) {
          // Private mode: return_url on the logout link still applies.
        }
      });
    }
  }

  function showReturnNoticeIfNeeded() {
    var stored;
    try {
      stored = window.sessionStorage.getItem(RETURN_KEY);
    } catch (error) {
      return;
    }
    if (!stored) return;

    // Only show once, and only back on a product page where Add to Cart is
    // now available (i.e. the customer really is signed out).
    try {
      window.sessionStorage.removeItem(RETURN_KEY);
    } catch (error) {
      return;
    }

    if (document.querySelector('[data-vk-b2b-purchase-choice]')) return;

    var form = document.querySelector('product-form-component');
    if (!form || !form.parentNode) return;

    var notice = document.createElement('div');
    notice.className = 'vk-b2b-personal-notice';
    notice.setAttribute('role', 'status');

    var text = document.createElement('span');
    text.textContent = 'Continue with a different email address for your personal purchase.';

    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'vk-b2b-personal-notice__dismiss';
    dismiss.setAttribute('aria-label', 'Dismiss');
    dismiss.textContent = '×';
    dismiss.addEventListener('click', function () {
      notice.remove();
    });

    notice.appendChild(text);
    notice.appendChild(dismiss);
    form.parentNode.insertBefore(notice, form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
